<template>
	<div class="container">
		<van-form @submit="onSubmit">
			<div class="wrapper-div">
			  <span style="color:#333;font-size: 18px;font-weight: 500">
				请上传您的经营场所照片
			  </span>
			
			  <div class="upload-div" style="justify-content: space-between">
				<div class="upload-div-item">
				  <uploadImage
					:imgSrc="otherImage"
					submit-field="upFileUrl6"
					type="other"
					:access_token="access_token"
					img-class-name="upload-other-img"
					file-type="1"
					@uploadSuccess="uploadSuccess"
				  />
				  <span>门头照照片</span>
				</div>
				<div class="upload-div-item">
				  <uploadImage
					:imgSrc="otherImage"
					submit-field="upFileUrl4"
					type="other"
					:access_token="access_token"
					img-class-name="upload-other-img"
					file-type="1"
					@uploadSuccess="uploadSuccess"
				  />
				  <span>经营场所照片</span>
				</div>
			  </div>
			
			  <div class="upload-div">
				<div class="upload-div-item">
				  <uploadImage
					:imgSrc="otherImage"
					submit-field="upFileUrl9"
					type="other"
					:access_token="access_token"
					img-class-name="upload-other-img"
					file-type="1"
					@uploadSuccess="uploadSuccess"
				  />
				  <span>收银台照片</span>
				</div>
			  </div>
			</div>
			<div class="button-text">
				<van-button round block color="linear-gradient(to right, #FFCE05, #FBC002)" native-type="submit">
					提交
				</van-button>
			</div>
		</van-form>
	</div>
</template>

<script>
import uploadImage from '@/components/UploadImage.vue'
import otherImage from '@/assets/images/upload_other.png'
export default {
	components: {
	  uploadImage
	},
	name: 'aliReportMakeUpPic',
  data () {
    return {
		otherImage: otherImage,
		access_token: '',
		merId: '',
		submitParams: {},
		picInfo: {},
    }
  },
  mounted() {
  	let param = this.$route.query
  	this.merId = param.merId
	// this.getPicInfo()
  },
  methods: {
	getPicInfo(){
		let params = {
			merId: this.merId
		}
		this.getRequest('/api/cold-butler-compose/aliAuthH5/qryMerFailThreePic', params).then(res => {
		  console.log('返回数据1',res)
		  if (res && res.data.code === 200) {
			this.picInfo = res.data.data
		  }else{
			this.$toast(res.data.msg, { type: 'fail' })
		  }
		})
	},
	onSubmit(){
		let param = {...this.submitParams}
		param.merId = this.merId
		console.log('参数',param)
		this.jsonPostRequest('/api/cold-butler-compose/aliAuthH5/supplementThreePic', param).then(res => {
		 console.log('返回数据',res)
		  if (res && res.data.code === 200) {
			  this.$toast(res.data.msg, { type: 'success' })
			this.$router.back()  
		  } else {
		    this.$toast(res.data.msg, { type: 'fail' })
		  }
		})
	},
	uploadSuccess({ type, imgBase64, data, field }) {
		this.submitParams[field] = imgBase64
	}
  }
}
</script>
<style>
	.wrapper-div {
	  background-color: #fff;
	  border-radius: 5px;
	  padding: 5px 10px;
	  margin: 10px 15px 0;
	}
	.upload-div {
	  display: flex;
	  justify-content: center;
	  margin-top: 10px;
	}
	.upload-div-item {
	  background-color: #fffbf3;
	  display: flex;
	  flex-direction: column;
	  align-items: center;
	  justify-content: center;
	  height: 110px;
	  width: 150px;
	}
	.button-text {
	  height: 60px;
	  width: 100%;
	  background-color: #fff;
	  display: flex;
	  justify-content: center;
	  align-items: center;
	  position: fixed;
	  bottom: 0;
	}
</style>
